import Requests from './Requests'

export default Requests
